import { routeTypes } from "../hooks/useSystemRoutes"

import { customLayoutFrames } from '../customization'

import defaultFrameAdmin from "../layouts/admin/Frame"
import defaultFrameWorkstation from "../layouts/workstation/Frame"
import defaultFrameCustomer from "../layouts/customer/Frame"
import defaultFramePublic from "../layouts/public/Frame"
import defaultFrameRetail from "../layouts/retail/Frame"
import defaultFrameMember from "../layouts/member/Frame"
import defaultFrameDriver from "../layouts/driver/Frame"

export const getLayoutFrame = ({ routeType }) => {

  let ComponentFrame;

  if (routeType === routeTypes.admin) {
    ComponentFrame = customLayoutFrames?.admin && customLayoutFrames.admin ? customLayoutFrames.admin : defaultFrameAdmin
    return <ComponentFrame />
  }

  if (routeType === routeTypes.workstation) {
    ComponentFrame = customLayoutFrames?.workstation && customLayoutFrames.workstation ? customLayoutFrames.workstation : defaultFrameWorkstation
    return <ComponentFrame />
  }

  if (routeType === routeTypes.retail) {
    ComponentFrame = customLayoutFrames?.retail && customLayoutFrames.retail ? customLayoutFrames.retail : defaultFrameRetail
    return <ComponentFrame />
  }

  if (routeType === routeTypes.customer) {
    ComponentFrame = customLayoutFrames?.customer && customLayoutFrames.customer ? customLayoutFrames.customer : defaultFrameCustomer
    return <ComponentFrame />
  }

  if (routeType === routeTypes.member) {
    ComponentFrame = customLayoutFrames?.member && customLayoutFrames.member ? customLayoutFrames.member : defaultFrameMember
    return <ComponentFrame />
  }

  if (routeType === routeTypes.public) {
    ComponentFrame = customLayoutFrames?.public && customLayoutFrames.public ? customLayoutFrames.public : defaultFramePublic
    return <ComponentFrame />
  }

  if (routeType === routeTypes.driver) {
    ComponentFrame = customLayoutFrames?.driver && customLayoutFrames.driver ? customLayoutFrames.driver : defaultFrameDriver
    return <ComponentFrame />
  }

  return false
}